import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';

@Injectable()
export class CepService {

  public cep: string;

  constructor(
    public http: HttpService,
    private httpClient: Http
  ) {

  }

  public byCep(cep: string): Observable<Response> {
    return this.http.pathRest().get('endereco/' + cep + '/', true);
  }

  public findByViaCep(cep: string): Observable<any> {
    return this.httpClient.get(`https://viacep.com.br/ws/${cep}/json/`);
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/cep.service.ts